var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaystoreLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8548 7.23243L5.33324 0.550647C4.89814 0.290047 4.39034 0.139648 3.84694 0.139648C2.72576 0.139648 1.73977 0.818929 1.26692 1.76851L1.35352 1.85509L11.7935 12.2928L16.8548 7.23243ZM0.972977 2.88869C0.971001 2.93103 0.970001 2.97354 0.970001 3.01622V22.9838C0.970001 23.0265 0.970999 23.0689 0.972974 23.1112L11.0863 12.9998L0.972977 2.88869ZM1.26695 24.2314C1.73987 25.181 2.726 25.8603 3.84694 25.8603C4.37864 25.8603 4.87784 25.7166 5.30594 25.4642L5.33994 25.4443L16.8746 18.7869L11.7935 13.7069L1.35352 24.1448L1.26695 24.2314ZM17.7714 18.2694L22.4684 15.5584C23.3707 15.0713 23.9832 14.1201 23.9832 13.0232C23.9832 11.9342 23.3789 10.9877 22.4856 10.499L22.4754 10.492L17.75 7.75155L12.5007 12.9998L17.7714 18.2694Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystoreLogo);
export default __webpack_public_path__ + "static/media/playstore-logo.9473a3007a2fc094b2fe3fa85cbe1758.svg";
export { ForwardRef as ReactComponent };